/// <amd-module name="Repos/Views/Settings/Repositories/Components/RepositoryPolicies" />
import React = require("react");
import { IBranchesProps } from "Repos/Views/Settings/Branches/Components/Branches/Branches.Props";
import { SimpleGitRef } from "Repos/Views/Settings/Branches/Data/SimpleGitRef";
import { IRepository } from "Repos/Views/Settings/Repositories/Contracts/Contracts";
import * as Resources from "Repos/Views/Settings/Repositories/Resources";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { IRepositoriesViewService } from "../Services/RepositoriesViewService";

interface IRepositoryPoliciesProps {
    createChildLayer?(): void;
}

export class RepositoryPolicies extends VssComponent<IRepositoryPoliciesProps> {
    private selectedRepo: IReadonlyObservableValue<IRepository | undefined>;
    private selectedRefs: IReadonlyObservableValue<string | undefined>;
    private svc: IRepositoriesViewService;

    public constructor(props: IRepositoryPoliciesProps, context: IVssComponentContext) {
        super(props, context);
        this.svc = context.pageContext.getService<IRepositoriesViewService>("RepositoriesViewService");
        this.selectedRepo = this.svc.getSelected();
        this.selectedRefs = this.svc.getSelectedRefs();
    }

    public render = (): JSX.Element => {
        return (
            <div className="rhythm-vertical-20">
                <Observer selected={this.selectedRepo} selectedRefs={this.selectedRefs}>
                    {(props: { selected: IRepository | undefined; selectedRefs: string | undefined }) => {
                        return (
                            <>
                                <WrappedComponent
                                    loadingComponent={renderLoading}
                                    dependencies={["ms.vss-code-web.settings-repositories-policies"]}
                                    wrappedProps={{
                                        repositoryId: this.selectedRepo.value && this.selectedRepo.value.id,
                                        repositoryName: this.selectedRepo.value && this.selectedRepo.value.name,
                                        goToProject: this.goToProject,
                                        goToRef: this.goToRef,
                                        refName: this.selectedRefs.value
                                    }}
                                    wrappedType="ms.vss-code-web.repositories-policies-component"
                                />

                                {
                                    // Cross-repo branch policies for project
                                    !this.selectedRepo.value && !this.selectedRefs.value && (
                                        <WrappedComponent<any>
                                            loadingComponent={renderLoading}
                                            dependencies={["ms.vss-code-web.settings-project-branch-policies"]}
                                            wrappedProps={{ setSelectedRefs: this.svc.setSelectedRefs }}
                                            wrappedType="settings-project-branch-policies-view"
                                        />
                                    )
                                }

                                {
                                    // Branch policies for repo
                                    this.selectedRepo.value && !this.selectedRepo.value.isTfvc && !this.selectedRefs.value && (
                                        <WrappedComponent<IBranchesProps>
                                            loadingComponent={renderLoading}
                                            dependencies={["ms.vss-code-web.settings-branches"]}
                                            wrappedProps={{
                                                cardTitle: Resources.BranchPolicies,
                                                cardDescription: Resources.BranchPoliciesDescription,
                                                projectId: this.svc.getProject().id!,
                                                repositoryId: this.selectedRepo.value.id,
                                                onRowActivate: this.onRowActivate
                                            }}
                                            wrappedType="settings-branches-component"
                                        />
                                    )
                                }
                            </>
                        );
                    }}
                </Observer>
            </div>
        );
    };

    private goToProject = () => {
        this.svc.setAllWithSinglePageHistoryEntry(undefined, undefined, "policies");
    };

    private goToRef = (refName: string, repositoryId?: string) => {
        this.svc.setAllWithSinglePageHistoryEntry(repositoryId, refName, repositoryId ? "policiesMid" : "policies");
    };

    private onRowActivate = (ref: SimpleGitRef) => {
        let selectedRef = ref.ref;

        if (ref.isFolder) {
            // if folder in policies, need to append wildcard to get things to work correctly
            selectedRef += "*";
        }
        this.svc.setSelectedRefs(selectedRef);
        this.props.createChildLayer && this.props.createChildLayer();
    };
}

function renderLoading() {
    return <Spinner size={SpinnerSize.large} />;
}
